<template>
  <div style="box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);height: 100%">
    <div style="text-align: left;text-align: left;width: 85%;display: inline-block;margin: 20px 0px;">
      <h1>2021APCF “破维开新局”，张晓强：是创新，是未来！</h1>
      <h3>时间：2021-12-16 17:22:54</h3>
      <el-divider></el-divider>
      <div>
        2021年11月2日-3日，风云际会上海滩，2021亚太酒店与地产合作论坛（APCF）正式举办。亚太酒店与地产合作论坛（APCF）为亚太地区重要合作平台之一，
        致力于促进亚太地区住宿、餐饮、旅游与产业地产的多边合作和可持续健康发展，锦江国际集团副总裁、锦江酒店董事长、锦江酒店（中国区）董事长张晓强受邀出席，并就“破维开新局”主题、以“创新”为要分享了相关思考与实践。
        “14薪”的薪酬体系，在整个中国餐饮零售行业尚属罕见。这是星巴克中国又一次勇于挑战自我的重要一步，也彰显其未来在中国大力发展的决心。在星巴克的价值观中，一贯承诺“与伙伴分享成就”，此次薪酬调整也是对这一承诺的又一次全新印证。<br/>
        “进入中国22年来，星巴克始终致力于成为一家与众不同的公司。我们一直将伙伴视为星巴克的心跳、一切事业的基石。我们渴望将所获得的成就，尽可能地与所有伙伴分享；不仅帮助伙伴在职业上取得成功，也能让伙伴一起过上更好的生活。”星巴克中国首席执行官蔡德粦说，“唯有伙伴感到快乐幸福，才能为顾客呈现更好的咖啡体验，我们才有机会持续获得成功。”
<br/>
        除“14薪”以外，星巴克中国也持续加大了对于福利的投资力度，对现有的伙伴福利进行了大幅升级，包括：有竞争力的年度绩效调薪；更优化的早晚班津贴；在部分城市升级“助房津贴”额度；鼓励伙伴到不同城市体验的“伙伴识天下”计划等等。
        <br/>
        一直以来，星巴克在薪酬福利领域保持了高度的创新活力，推出过众多引领行业风潮的项目：包括行业至今鲜有的“咖啡豆股票”、为伙伴父母提供重疾保险的“父母关爱计划”、囊括HPV疫苗、宠物关爱等内容的个性化“星福利”等。星巴克坚信，唯有不断提升伙伴的幸福指数，才能与伙伴共同走向成功。
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "NewsDt",
  data() {
    return {

    }
  },
  methods: {
    goBack(){

    }
  },
  components: {
  }
}
</script>

<style scoped>

</style>
